import React from 'react';

const CustomImg = (props) => (
  <img
    {...props}
    alt={props.alt || ''}
    onError={(e) => {
      e.target.onerror = null;
      e.target.src = '/image-not-available.jpg';
    }} />
);

export default CustomImg;
